import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { useClient } from '../../context/ClientContext';

export default function DayOfWeek({ dateRange }) {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetcher.fetchDayOfWeek(dateRange)
      .then(setData)
      .finally(() => setLoading(false));
  }, [dateRange]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/4 mb-4"></div>
        <div className="h-48 bg-gray-200 rounded"></div>
      </div>
    );
  }

  if (!data?.days?.length) return null;

  const primaryColor = brand.colors?.primary || '#2563eb';
  const currency = data.currency || '$';

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Day of Week
      </h3>
      <p className="text-xs text-gray-400 mb-4">Conversions by day</p>

      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data.days} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
          <XAxis
            dataKey="day"
            tick={{ fontSize: 12, fill: '#666' }}
            tickLine={false}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: '#666' }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            formatter={(value, name) => {
              if (name === 'conversions') return [value, 'Conversions'];
              return [value, name];
            }}
            labelStyle={{ fontWeight: 600 }}
            contentStyle={{ borderRadius: 8, border: '1px solid #e5e7eb' }}
            content={({ active, payload, label }) => {
              if (!active || !payload?.length) return null;
              const d = payload[0]?.payload;
              if (!d) return null;
              return (
                <div className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm text-sm">
                  <p className="font-semibold text-gray-900 mb-1">{label}</p>
                  <p className="text-gray-600">{d.conversions} conversions</p>
                  <p className="text-gray-600">{currency}{d.cost.toFixed(0)} spend</p>
                  <p className="text-gray-600">{d.convRate.toFixed(1)}% conv. rate</p>
                  {d.conversions > 0 && <p className="text-gray-600">{currency}{d.cpa.toFixed(0)} CPA</p>}
                </div>
              );
            }}
          />
          <Bar
            dataKey="conversions"
            fill={primaryColor}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
